import { render, staticRenderFns } from "./DiscussList.vue?vue&type=template&id=03810103&scoped=true"
import script from "./DiscussList.vue?vue&type=script&lang=js"
export * from "./DiscussList.vue?vue&type=script&lang=js"
import style0 from "./DiscussList.vue?vue&type=style&index=0&id=03810103&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03810103",
  null
  
)

export default component.exports